import PreviousPayPeriods from './PreviousPayPeriods'
import YearEndStatements from './YearEndStatements'

export default {
	PreviousPayPeriods,
	YearEndStatements,
}
